import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__ from "date-fns";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__calendar_mjs_1a75f28e__ from "./calendar.mjs";
function DatePicker(props) {
    const { mode = "single", className, dateFormat = "PPP", placeholder = "", value, onValueChange, onKeyDown, ...other } = props;
    const [singleValueInternal, setSingleValueInternal] = __WEBPACK_EXTERNAL_MODULE_react__.useState(void 0);
    const [rangeValueInternal, setRangeValueInternal] = __WEBPACK_EXTERNAL_MODULE_react__.useState(void 0);
    const [open, setOpen] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const singleValue = value || singleValueInternal;
    const rangeValue = value || rangeValueInternal;
    const handleCalendarSelect = (val)=>{
        if ("single" === mode && val instanceof Date) {
            null == onValueChange || onValueChange(val);
            setSingleValueInternal(val);
        } else if ("range" === mode && "object" == typeof val && null !== val) {
            null == onValueChange || onValueChange(val);
            setRangeValueInternal(val);
        }
    };
    const handleKeyDown = (event)=>{
        const key = event.key;
        if ("Delete" === key || "Backspace" === key) {
            setSingleValueInternal(void 0);
            setRangeValueInternal(void 0);
            null == onValueChange || onValueChange(void 0);
        }
        null == onKeyDown || onKeyDown(event);
    };
    const renderValue = ()=>{
        if ("single" === mode && singleValue instanceof Date) return (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(singleValue, dateFormat);
        if ("range" === mode && rangeValue && "from" in rangeValue) {
            const { from, to } = rangeValue;
            if (from && to) return `${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(from, dateFormat)} - ${(0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(to, dateFormat)}`;
            if (from) return (0, __WEBPACK_EXTERNAL_MODULE_date_fns_925206bc__.format)(from, dateFormat);
        }
        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
            children: placeholder
        });
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
        open: open,
        onOpenChange: setOpen,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                    variant: "outline",
                    ...other,
                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("!tw-justify-start", "tw-text-left", "tw-font-normal", className, {
                        ["text-muted-foreground"]: !value
                    }),
                    onKeyDown: handleKeyDown,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CalendarIcon, {
                            className: "tw-mr-2 tw-h-4 tw-w-4"
                        }),
                        renderValue()
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                className: "tw-w-auto tw-p-0",
                align: "start",
                children: [
                    "single" === mode && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__calendar_mjs_1a75f28e__.Calendar, {
                        mode: "single",
                        required: true,
                        selected: singleValue,
                        onSelect: handleCalendarSelect
                    }),
                    "range" === mode && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__calendar_mjs_1a75f28e__.Calendar, {
                        mode: "range",
                        required: true,
                        selected: rangeValue,
                        onSelect: handleCalendarSelect
                    })
                ]
            })
        ]
    });
}
export { DatePicker };

//# sourceMappingURL=date-picker.mjs.map